import React, { FC, useEffect, useRef, useState } from "react";
import { useContent } from "contexts/contentContext/contentContext.js";

type TooltipModalWrapperProps = {
  targetRef: HTMLDivElement | undefined;
  pos: string;
  children: JSX.Element;
};

const TooltipModalWrapper: FC<TooltipModalWrapperProps> = ({
  targetRef,
  pos,
  children,
}) => {
  const [cords, setCords] = useState({});
  const modalWindowRef = useRef(null);
  const { getDirection } = useContent();

  const artistMessagePos = targetRef?.getBoundingClientRect();

  const handlePosition = () => {
    if (
      modalWindowRef.current &&
      artistMessagePos &&
      cords?.left === undefined
    ) {
      const windowCoords = modalWindowRef.current?.getBoundingClientRect();
      if (!windowCoords) return;
      // get size of the modal window
      const height = windowCoords.height;
      let right 
      let left 

      if (pos === "left") {
        right = getDirection() === "ltr" ? "unset" : 0;
        left = getDirection() === "rtl" ? "unset" : 0;
      }else{
         right = getDirection() === "ltr" ? 0 : "unset";
         left = getDirection() === "rtl" ? 0 : "unset";
      }
      const top = -height - 10;
      setCords({ right, top, left });
    }
  };

  useEffect(() => {
    setTimeout(() => {
      handlePosition();
    }, 100);
  }, []);

  return (
    <div className="homepage-tooltip-modal" style={cords} ref={modalWindowRef}>
      {children}
      <div className={`tooltip-arrow ${pos === "left" ? "arrow-left" : "arrow-right"}`} />
    </div>
  );
};

export default TooltipModalWrapper;
